import { useEffect, useState } from "react";
import { TRANSACTION_EXPIRATIONS } from "../../constants/api";
import { Bounce, ToastContainer } from "react-toastify";
import { errorNotify, successNotify } from "../../shared/notifications";
import axiosHttp from "../interceptors/axios-interceptor";
import { persianLanguage } from "../../constants/persianTerms";
import { Button, NumberBox } from "devextreme-react";
import TransactionExpirationDurationHistory from "./transaction-expiration-duration-history/transaction-expiration-duration-history";
import { persianPrice } from '../../shared/persian-number';
import { useAuth } from "../auth/auth-provider/auth-provider";

import "./transaction-expiration-duration.css";


export default function TransactionExpirationDuration(){
    

    const [transactionExpirationDuration, setTransactionExpirationDuration] = useState();

    const [duration, setDuration] = useState(0);
    const [newValue, setNewValue] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);


    const auth = useAuth();

    useEffect(() => {
        getTransactionExpirationDuration();
    }, [newValue]);

    const getTransactionExpirationDuration = () => {
        axiosHttp.get(`${TRANSACTION_EXPIRATIONS}${auth?.user?.id}/`).then(
            response => {
                setTransactionExpirationDuration(response.data);
                setDuration(response.data.expirationDuration);
            }
        ).catch(
            error => {
                setTransactionExpirationDuration(null)
                setDuration(0);
            }
        );
    }

    const handlePrice = (e) =>{
        // console.log('e issssssss: ', e)
        setNewValue(e.event.target.value);
    }

    const changeCreditValue = () => {
        const formData = new FormData()
        formData.append('expirationDuration', newValue);
        const api = `${TRANSACTION_EXPIRATIONS}${auth?.user?.id}/`;
        axiosHttp.patch(api, formData).then(
            response => {
                successNotify(`
                    ${persianLanguage.phrase.success.SUCCESS_201}
                    `);
                    setNewValue(null);
            }
        ).catch(
            error => {
                if(error?.response?.status === 403){
                    errorNotify(persianLanguage.phrase.error.ERROR_403);
                } else if(error?.response?.status === 404){
                    
                }
                else if (error?.response?.status === 500){
                    errorNotify(persianLanguage.phrase.error.ERROR_500);
                }
                else{
                    errorNotify(persianLanguage.phrase.error.ERROR_400);
                }
            }
        );
    }

    const handleSubmit = () => {
        if( newValue === 0 || newValue === null){
            setErrorMessage(persianLanguage.phrase.required.AMOUNT_REQUIRED);
        } else {
            setErrorMessage(null);
            changeCreditValue();
        }
    }

    return (
        <>
            <div className="user-select-none mt-5 p-5 grid grid-cols-1 xs:grid-cols-2 bg-primary-main border border-2 border-primary-fourth-30p box-shadow-0-4-4-0 mx-[28px]">
                <div className="flex justify-center items-center">
                    <form onSubmit={handleSubmit}>
                        <div>
                            <div class="grid md:grid-cols-2 grid-cols-1 gap-1  ">
                            <div>
                                <NumberBox
                                value={newValue}
                                className="mt-5 bg-primary-second border border-1 border-primary-third box-shadow-0-4-4-0"
                                rtlEnabled={true}
                                placeholder={persianLanguage.phrase.transaction.RECORD_NEW_TRANSACTION_EXPIRATION_DURATION}
                                onChange={(e) => handlePrice(e)}
                                />
                                {errorMessage && <span className='bg-red-100 border border-red-500 text-red-700 px-4 py-1 rounded relative'>{errorMessage}</span>}
                            </div>
                            <div className='flex justify-end'>
                                <Button
                                text={persianLanguage.word.general.REGISTER}
                                className="submit-duration bg-success-main white border border-1 rounded-[24px] content-end mt-5"
                                stylingMode="outlined"
                                onClick={(e) => handleSubmit(e)}/>
                            </div>
                            </div>
                            <div>
                            </div>
                        </div>
                    </form>
                </div>                
                <div className=" flex justify-center items-center ">
                    <div className="duration-box flex flex-col items-center box-shadow-0-4-4-0  gap-4">
                        {/* Circle */}
                        <div className="duration-circle border-4 border-blue-500 rounded-full flex flex-col justify-center items-center p-2">
                            <div className="font-bold">{persianPrice(duration)}</div>
                            {transactionExpirationDuration && (
                                <div className="text-xs">{persianLanguage.word.time.SECOND}</div>
                            )}
                        </div>

                        {/* Label */}
                        <div className="text-center max-w-xs px-4">
                            {persianLanguage.phrase.transaction.AUTOMATIC_TRANSACTION_EXPIRATION_DURATION}
                        </div>
                    </div>
                </div>

            </div>

            <TransactionExpirationDurationHistory duration={newValue} />
        </>
    );
}